import React from 'react';
import { css, cx } from 'linaria';
import { theme } from '../components/Theme';

const badgeClassName = css`
  white-space: nowrap;
  color: ${theme.colors.black};
  background: ${theme.colors.white};
  border: none;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 600;
  padding: 8px 6px;
  display: inline-block;
  border-radius: 1.2px;

  &.round {
    background: ${theme.colors.offWhite};
    color: ${theme.colors.tretornBlue};
    border: none;
    min-width: 2rem;
    max-width: 5rem;
    border-radius: 3rem;
    aspect-ratio: 1 / 1;
    text-align: center;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    padding: 0.8rem 0.75rem 0.7rem;
    font-size: 1rem;
    white-space: nowrap;
    line-height: 1;
  }
`;

export default function DiscountBadge({
  round,
  rectangle,
  children,
  className
}) {
  return (
    <div
      className={cx(
        badgeClassName,
        className,
        rectangle && 'rectangle',
        round && 'round'
      )}
    >
      {children?.length ? <span className="text">{children}</span> : null}
    </div>
  );
}
